import React from 'react';
import css from './CMSPageSkeleton.module.css';

const Shimmer = () => <div className={css.shimmer} />;

/**
 * Full-page skeleton for CMS pages (Help Center, How It Works, etc.)
 * Used while the page is loading to prevent a white screen flash.
 */
const CMSPageSkeleton = () => {
  return (
    <div className={css.root}>
      {/* Topbar placeholder */}
      <div className={css.topbarPlaceholder} />

      {/* Content skeleton */}
      <div className={css.container}>
        <div className={css.hero}>
          <Shimmer />
        </div>

        <div className={css.title}>
          <Shimmer />
        </div>

        <div className={css.sectionBlock}>
          <div className={css.lineLong}>
            <Shimmer />
          </div>
          <div className={css.lineMedium}>
            <Shimmer />
          </div>
          <div className={css.lineShort}>
            <Shimmer />
          </div>
        </div>

        <div className={css.cardsGrid}>
          <div className={css.card}>
            <Shimmer />
          </div>
          <div className={css.card}>
            <Shimmer />
          </div>
          <div className={css.card}>
            <Shimmer />
          </div>
        </div>

        <div className={css.sectionBlock}>
          <div className={css.title}>
            <Shimmer />
          </div>
          <div className={css.lineLong}>
            <Shimmer />
          </div>
          <div className={css.lineMedium}>
            <Shimmer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CMSPageSkeleton;
